/* eslint-disable react/destructuring-assignment */
import React from 'react';
import PropTypes from 'prop-types';

import NavItemTooltip from '../NavItemTooltip';
// import { sendActionTag } from '../../../../../../../../externals/partners/xiti';

import t from '../../../../../../../../css/global.module.css';
import s from './navItemCart.module.css';


const NavItemCart = (props) => {
  const { nbProducts, data: { xiti } } = props;
  let notifs = '';
  if (nbProducts > 0) {
    notifs = <div className={`${t.b} ${s.flag}`}>{nbProducts}</div>;
  }
  const callXiti = () => {
    if (xiti && xiti.onShowCart) {
      if (window.partners_iso) {
        window.partners_iso.sendXitiClickTag(xiti.onShowCart);
      }
    }
  };

  return (
    <NavItemTooltip
      {...props}
      destroyTooltipOnHide
      notifs={notifs}
      onShow={callXiti}
    />
  );
};

//
// }
//   constructor(props) {
//     super(props);
//
//     this.state = {
//       nbPrd: props.data.nbProducts || 0,
//     };
//
//     this.notifs = this.notifs.bind(this);
//     this.getOnShow = this.getOnShow.bind(this);
//     this.updateStore = this.updateStore.bind(this);
//   }
//
//   componentDidMount() {
//     this.props.store.register('NavItemCart', this.updateStore);
//   }
//
//   /**
//    * This will be called by the NavItem tooltip component.
//    */
//   getOnShow() {
//     const xitiInfos = this.props.data.xiti;
//     // call xiti
//     function callXiti() {
//       if (xitiInfos && xitiInfos.onShowCart) {
//         sendActionTag(xitiInfos.onShowCart);
//       }
//     }
//     return callXiti;
//   }
//
//   updateStore() {
//     const store = this.props.store.getStore();
//     const nbPrd = store.nbProducts;
//     this.setState({
//       nbPrd,
//     });
//   }
//
//   notifs() {
//     if (this.state.nbPrd > 0) {
//       return (<div className={`${t.b} ${s.flag}`}>{this.state.nbPrd}</div>);
//     }
//     return '';
//   }
//
//   render() {
//     return (
//       <NavItemTooltip
//         {...this.props}
//         notifs={this.notifs()}
//         onShow={this.getOnShow()}
//       />
//     );
//   }
// }


NavItemCart.propTypes = {
  nbProducts: PropTypes.number,
  data: PropTypes.objectOf(
    PropTypes.oneOfType([
      PropTypes.string,
      PropTypes.object,
      PropTypes.bool,
      PropTypes.number,
      PropTypes.arrayOf(PropTypes.object)]),
  ).isRequired,
  alignTooltipRight: PropTypes.bool,
};

NavItemCart.defaultProps = {
  nbProducts: 0,
  alignTooltipRight: false,
};

export default NavItemCart;
